import { useAuthStore } from '@/app/modules/auth/stores/AuthStore';

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  if (to.query?.session_state && to.query?.code) {
    const { status } = await useAsyncData(() => {
      if (to.query?.session_state && to.query?.code) {
        return authStore.setSession(to.query.session_state?.toString(), to.query.code?.toString(), to.query.pass_entrance?.toString() === 'true');
      }
      return new Promise(resolve => resolve(false));
    });
    if (status.value === 'success') {
      return navigateTo(to.path);
    }
    else {
      throw createError({
        status: 401,
        statusMessage: 'Ошибка авторизации',
      });
    }
  }
});
